export default {"src":"/_next/static/media/check.b7f44181.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};